<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>link</mat-icon>&nbsp;<span *ngIf="association.householdId > 0">Associate Housing Unit to a
        Household</span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" [disabled]='loading'>Close</button>
  </div>
</div>

<mat-dialog-content>
  <!-- Housing Unit search -->
  <form #form="ngForm" [formGroup]="housingUnitSearchForm" class="form-field-full"
    *ngIf="!loading && association.householdId > 0">
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <mat-card>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Contact</mat-label>
                <input id="contactName" name="contactName" formControlName="contactName" matInput
                  placeholder="Contact Name" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard" style="width:100%;">
                <mat-label>Address</mat-label>
                <input id="address1" name="address1" formControlName="address1" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>City</mat-label>
                <input id="city" name="city" formControlName="city" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>Zip</mat-label>
                <input id="zip" name="zip" formControlName="zip" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field appearance="standard">
                <mat-label>County</mat-label>
                <mat-select id="county" name="county" formControlName="county">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <button type="submit" id="submitButtonSearch" (click)="searchHousingUnits()" mat-raised-button color="primary"
          title="Search" [disabled]='loading'>Search</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear"
          [disabled]='loading'>Clear</button>
      </div>
    </div>
  </form>

  <br /><br />

  <!-- Housing Unit Search Results -->
  <mat-card *ngIf="!loading && this.association.householdId > 0">
    <strong class="noMarginHeader">Search Results ({{housingUnitSearchResults.length}})</strong>
    <br /><br />
    <table mat-table [dataSource]="dataSourceHousingUnits" matSort (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8" style="width: 100%;overflow-x: auto;">
      <tr mat-header-row *matHeaderRowDef="displayedColumnsHousingUnits"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsHousingUnits;"></tr>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef scope="col">&nbsp;&nbsp;&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <input type="radio" id="id" name="id" value="{{element.id}}"
            (click)="onChangeSelectedHousingUnit(element.id)" />
        </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id">
          OHA <br /> Housing <br /> Unit Id
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.id}} </td>
      </ng-container>
      <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Contact Name">
          Contact Name
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.contactName}}</td>
      </ng-container>
      <ng-container matColumnDef="address1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address">
          Address
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.address1}} </td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by city">
          City
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.city}} </td>
      </ng-container>
      <ng-container matColumnDef="zip">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by zip">
          Zip
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.zip}} </td>
      </ng-container>
      <ng-container matColumnDef="county">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by county">
          County
        </th>
        <td mat-cell *matCellDef="let element"> &nbsp;&nbsp;{{element.county}} </td>
      </ng-container>
    </table>

    <br /><br>

    <form #form="ngForm" [formGroup]="housingUnitForm" class="form-field-full">
      <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
        <div fxFlex.lt-sm="100">
          <mat-checkbox formControlName="createNewHousingUnit" (click)="onChangeCreateNewHousingUnit()">
            Create New Housing Unit <small>(Information in the Search section above will be used)</small>
          </mat-checkbox>
        </div>
      </div>

      <br /><br />

      <!-- Dates -->
      <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
        <div fxFlex.lt-sm="50">
          <strong class="noMarginHeader">Housing Unit Dates</strong>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
        <div fxFlex.lt-sm="50">
          <mat-form-field appearance="standard">
            <mat-label>Start Date</mat-label>
            <input id="housingUnitStartDate" name="housingUnitStartDate" formControlName="housingUnitStartDate"
              placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerHousingUnitStartDate" />
            <mat-datepicker-toggle matSuffix [for]="datepickerHousingUnitStartDate"></mat-datepicker-toggle>
            <mat-datepicker #datepickerHousingUnitStartDate>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex.lt-sm="50">
          <mat-form-field appearance="standard">
            <mat-label>End Date</mat-label>
            <input id="housingUnitEndDate" name="housingUnitEndDate" formControlName="housingUnitEndDate"
              placeholder="mm/dd/yyyy" matInput [matDatepicker]="datepickerHousingUnitEndDate" />
            <mat-datepicker-toggle matSuffix [for]="datepickerHousingUnitEndDate"></mat-datepicker-toggle>
            <mat-datepicker #datepickerHousingUnitEndDate>
              <mat-datepicker-actions>
                <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                <button mat-button matDatepickerCancel>Cancel</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card>

  <!-- Association form -->
  <div fxLayout="row wrap" class="matero-row" *ngIf="!loading">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <button type="submit" id="submitButtonSearch" (click)="associateHousingUnit()" mat-raised-button color="primary"
        *ngIf="this.association.householdId > 0 || this.association.createNewHousingUnit == true" title="Associate Housing Unit to Household" 
        [disabled]='loading || (selectedHousingUnitId == 0 && association.createNewHousingUnit == false)'>Associate
        Housing Unit to Household</button>
    </div>
  </div>
</mat-dialog-content>